import { Tabs, TabsContent, TabsList, TabsTrigger } from '@talentmesh/ui/components/tabs';
import { useState } from 'react';

import DetailedBreakdownBenchmarkTab from './DetailedBreakdownBenchmarkTab';
import OverallScoreBenchmarkTab from './OverallScoreBenchmarkTab';
import { AssessmentMeanBenchmark } from '@/Models/AssessmentMeanBenchmark';
import { TestTypes } from '@/Models/Configuration';
import { TestScore } from '@/Models/TestScore';
import UIStrings from '@/Utils/UIStrings';

interface BenchmarkTabsProps {
    candidateFirstName: string;
    candidateScore: TestScore;
    testType: TestTypes;
    benchmark: AssessmentMeanBenchmark;
}

function BenchmarkTabs({ candidateFirstName, candidateScore, testType, benchmark }: BenchmarkTabsProps) {
    const [tabValue, setTabValue] = useState<string>(UIStrings.BenchmarkOverallScore);

    return (
        <Tabs value={tabValue} onValueChange={setTabValue} className="w-full">
            <TabsList variant="line-primary" className="mx-auto mt-5 w-full justify-center">
                <TabsTrigger value={UIStrings.BenchmarkOverallScore}>{UIStrings.BenchmarkOverallScore}</TabsTrigger>
                <TabsTrigger value={UIStrings.BenchmarkDetailedBreakdown}>
                    {UIStrings.BenchmarkDetailedBreakdown}
                </TabsTrigger>
            </TabsList>
            <TabsContent value={UIStrings.BenchmarkOverallScore}>
                <OverallScoreBenchmarkTab
                    candidateFirstName={candidateFirstName}
                    candidateScore={candidateScore.percentileScore}
                    testType={testType}
                    benchmark={benchmark}
                />
            </TabsContent>
            <TabsContent value={UIStrings.BenchmarkDetailedBreakdown}>
                <DetailedBreakdownBenchmarkTab
                    candidateFirstName={candidateFirstName}
                    topicScores={candidateScore.scores}
                    testType={testType}
                    benchmark={benchmark}
                />
            </TabsContent>
        </Tabs>
    );
}

export default BenchmarkTabs;
